import { AppError } from './app.error';

export class MigrationError extends AppError {
    override message = 'Migration Error';
}
